import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncDocumentUploadPending = loadable(
  () => import('./DocumentUploadPending'),
  {
    fallback: <Loader />,
  },
);

export const AsyncKYCUploadPending = AsyncDocumentUploadPending;
